import { render, staticRenderFns } from "./ListRepairPage.vue?vue&type=template&id=54933be7"
import script from "./ListRepairPage.vue?vue&type=script&lang=js"
export * from "./ListRepairPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports